module.exports = __webpack_public_path__ + "static/media/TvShowBanner (10).600a977b.png";